import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds';
import { RouteConfig } from 'vue-router';

const rotasDeMarketplace: RouteConfig[] = [
	{
		path: 'marketplace/configuracoes',
		name: 'Configurações Marketplace',
		components: {
			default: () =>
				import('@/views/application/marketplace/TelaDeConfiguracoesMarketplace.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
	},
	{
		path: 'marketplace/pedidos',
		name: 'Pedidos Marketplace',
		components: {
			default: () =>
				import('@/views/application/marketplace/TelaDePedidosMarketplace.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
	},
	{
		path: 'marketplace/produtos',
		name: 'Produtos Marketplace',
		components: {
			default: () =>
				import('@/views/application/marketplace/TelaDeProdutosMarketplace.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
	},
	/*{
		path: 'marketplace/categorias-comerciais',
		name: 'Categorias Comerciais',
		components: {
			default: () =>
				import('@/views/application/marketplace/TelaDeCategoriasComerciaisMarketplace.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
	},
	{
		path: 'marketplace/categorias',
		name: 'Categorias Marketplace',
		components: {
			default: () =>
				import('@/views/application/marketplace/TelaDeCategoriasDoMarketplace.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
	},*/
]

export default rotasDeMarketplace